import { useEffect, useState } from 'react'
import { getInstitutionsList } from '../api'
import { clinics as mockClinics } from '../constants/mockClinics'
import { mapToOptions } from '../utils/mapToOptions'
import to from 'await-catch'

export function useInstitutionOption({ showLoader, hideLoader, addFlashMessage }) {
  const [institutionOptions, setInstitutionOptions] = useState([])
  const [institutions, setInstitutions] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        showLoader && showLoader()
        
        const [err, [{ data: institutionsData } = {}]] = await to([getInstitutionsList()])
        if (err || !Array.isArray(institutionsData) || institutionsData.length === 0) {
          throw new Error('Error en el fetch de instituciones o respuesta vacía')
        }
        setInstitutionOptions(
          mapToOptions(institutionsData, 'id', 'descripcion')
        )
        setInstitutions(institutionsData)
      } catch (error) {
        addFlashMessage && addFlashMessage('Ocurrió un error cargando las instituciones')
      } finally {
        hideLoader && hideLoader()
      }
    }
    fetchData()
  }, [showLoader, hideLoader, addFlashMessage])

  return { institutionOptions, institutions }
}
